export * from "./capitalize.pipe";
export * from "./iq.pipe";
